import { runJsonPost, runJsonGet } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'
import { transformKeysToCamelCase } from './utils/casing'

export const invite = async teammatesIds => {
  await runJsonPost(
    `${OPERATIONS_BACKEND_URL}/accounts/commands/invite-teammates`,
    teammatesIds
  )
}

export const fetch = async () => {
  const response = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ordering/queries/teammates`
  )
  const result = transformKeysToCamelCase(response) as any
  return result.data
}
